import CancerPage from "../components/CancerPage";

const stepsText = [
  "A mammogram with additional views and/or ultrasound: These are often the first imaging tests performed after a suspicious finding.",
  "A biopsy: A tissue sample is taken from the suspicious area for pathological examination. This can be done via core needle biopsy, fine-needle aspiration, or surgical biopsy.",
  "Blood tests: To check for general health, organ function, and hormone receptor status.",
  "Further imaging (e.g., PET scan, MRI): To determine the full extent of the disease and check for spread to other organs.",
];

export default function BreastCancerPage() {
  return (
    <CancerPage
      cancerName="Breast Cancer"
      scanType="mammogram X-Ray / CT-Scan / MRI-Scan"
      analysisText="A significant area of breast tissue is identified with a high probability of malignancy, as indicated by the red-highlighted regions and the corresponding high-probability heatmaps. The model's predictions show that cancer is present and, in some cases, extensive within the tissue samples. As with any suspicious finding, histopathological confirmation via biopsy is the gold standard for definitive diagnosis. Further clinical correlation, including a thorough physical examination and consideration of patient risk factors, is advised to guide subsequent work-up and management."
      stepsTitle="Necessary Steps Following an Abnormal Breast Tissue Analysis:"
      stepsText={stepsText}
    />
  );
}
